import VTable from '@/vuetify_custom/v-table/v3'
import {VBtn, VTextField} from 'vuetify/lib'
import page_mixins from './page_mixins'
import Edit from './EditModal'
import PageContain from '@/views/components/PageContain.vue'
import VPage from '@/vuetify_custom/v-pagination'
import {getOutsourceContractTitleMappingQueryApi, postgetOutsourceContractdeleteApi} from './service'
export default {
    mixins:[page_mixins],
    data() {
        return {
            params: {
                page: 1,
                per_page: 10,
                search: '',
                total_count: 0,
            }
        }
    },
    computed: {
        fyzs_table() {
            return [
              
                {
                    text: '工作内容',
                    //  align: 'center',
                     value: 'job_content',
                },
                {
                    text: '职能',
                    //  align: 'center',
                     value: 'customer_function_id',
                     render:(val) => {
                       
                        return this.showCustomerFunctionName(val)
                     }
                },
                {
                    text: '是否量产',
                    //  align: 'center',
                     value: 'quantitative_output',
                     render:(val) => {
                       
                        return val ? '是' : '否'
                     }
                },
               
                {
                    text: '会计科目',
                    //  align: 'center',
                     value: 'account_title_id',
                     render:(val) => {
                       
                        return this.showAccountLeafTitle(val)
                     }
                },
                {
                    text: '分析科目',
                    //  align: 'center',
                     value: 'analysis_title_id',
                     // showAnalysisTitle
                     render:(val) => {
                       
                        return this.showAnalysisTitle(val)
                     }
                },
                {
                    text: '操作',
                    value: 'action_1',
                    width: 160,
                    fixed: 'right',
                    type: 'button_g_field',
                    buttons: ({target}) => {
                        return [
                            {
                              text: '编辑',
                              key: 'edit',
                              color: 'primary',
                              small: true,
                              _text: true,
                              callback: (data) => this.edit(data)
                            },
                            {
                                text: target.del ? '启用' : '停用',
                                key: 'edit',
                                color:target.del ? 'primary' : 'error',
                                small: true,
                                _text: true,
                                callback: () => {
                                 //changeStatusApi
                                 this.$vModal.confirm({
                                    title: '提示',
                                    content: `是否${target.del ? '启用' : '停用'}该条目？`,
                                    onOk:({
                                        destroy,
                                        // stopLoading
                                      }) => {
                                        postgetOutsourceContractdeleteApi({id:target.id}).then(() => {
                                            this.$Message.success('删除成功！')
                                            this.getListProxy()
                                        }).finally(() => {
                                            destroy()
                                        })
                                      }  
                                  })
                                }
                              },
                          ]
                    } 
                }
            ]
        },
    
    },
    created() {
        this.account_leaf_titles_hash
        this.analysis_titles_hash
        this.title_mappings_hash
        this.customer_functions_hash
    },
    methods: {
        edit(params) {
            this.$refs.edit.edit(params)
        },
        getListProxy(params = {}) {
            params = {
                ...this.params,
                ...params
            }
            this.loading = true
            getOutsourceContractTitleMappingQueryApi(params).then(res => {
              this.list = res.mappings
              this.params.total_count = res.total_count
            }).finally(() => {
              this.loading = false
            })
          },
    },
    render() {
        return (<div>
            <Edit ref="edit" on={{success: () => this.getListProxy({page:1})}}/>
            <div>
              <div style="width:300px;margin-right:10px;display:inline-block">
              <VTextField
                     
                     v-model={this.params.search}
                     append-icon="mdi-magnify"
                     // :placeholder="searchPlacehold"
           
                     // hide-details
                     clearable
                     on={{
                        'click:append': () => this.getListProxy(),
                        'keydown':(e) => {
                            if (e.code === 'Enter') {
                                this.getListProxy()
                            }
                          
                        },
                        'click:clear': () => this.getListProxy({...this.params, page:1, search:''})
                     }}
            
                 />
                  
              </div>
              <VBtn
                        small
                        depressed
                        color="primary"
                        dark
                        on={{
                            click:this.edit
                        }}
                        // @click="addNew"
                    >
                        新增条目
                    </VBtn>
                   
                    {/* <VCol style="display: flex;align-items: center">
                    <VBtn
                        small
                        depressed
                        color="primary"
                        dark
                        // @click="addNew"
                    >
                        新增条目
                    </VBtn>
                    </VCol> */}
              
            </div>
            <PageContain reserved-height={350}>
                <VTable 
                    fixedHeader
                    fixedHeaderZindex={3}
                    headers={this.fyzs_table}
                    desserts={this.list}
                    loading={this.loading}
        
                />
            </PageContain>
            <div class="paginate-fix-bottom" style="z-index:3">
             {!!this.params.total_count && <VPage
                current={this.params.page}
                total={this.params.total_count}
                page-size={this.params.per_page}
                size-arr={[10, 20, 50]}
                on={
                  {
                    changePageSize:(per_page) => {
                        this.params.per_page = per_page
                        this.params.page = 1
                        this.$nextTick(this.getListProxy)
                    },
                    pageChange:(page) => {
                        this.params.page = page
                        this.$nextTick(this.getListProxy)
                    }
                  }
                }
              />}
            </div>
            </div>)
    }
}